import React from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
import {DateRange, Input, LocalOffer, ShoppingCart, Store} from "@material-ui/icons";
import {Grid, MenuItem, Select, TextField, withStyles} from "material-ui";

import {ChartCard, IssuesCard, ItemGrid, RegularCard, StatsCard, Table, TasksCard} from "components";

import {completedTasksChart, dailyOrderChart, emailsSubscriptionChart} from "variables/charts";

import dashboardStyle from "assets/jss/material-dashboard-react/dashboardStyle";

import {store, oktaSignIn} from '../../index';
import {getReportForDays, storeSelectedNumber} from "../../service/reportActions";
import {connect} from "react-redux";
import Button from "../../components/CustomButtons/Button";

var Chartist = require("chartist");

export class DashboardPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0,
            reportDataLoaded: false,
            selectedunit: "days",
            activeunit: "days"
        };
    }

    componentDidMount() {
        this.loadReportData();
        this.interval = setInterval(this.loadReportData, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleChange = (event, value) => {
        this.setState({value});
    };

    loadReportData = () => {
        //const accessTokenObj = oktaSignIn.tokenManager.get('access_token');
        const accessTokenObj =
            oktaSignIn &&
            oktaSignIn.tokenManager &&
            oktaSignIn.tokenManager.get('access_token') &&
            Object.keys(oktaSignIn.tokenManager.get('access_token')).length > 0 &&
            oktaSignIn.tokenManager.get('access_token');

        accessTokenObj && store.dispatch(getReportForDays(this.props.selectednumber, this.state.selectedunit, accessTokenObj.accessToken)).then(() => {
            this.setState({
                reportDataLoaded: true,
                activeunit: this.state.selectedunit
            })
        });
    };

    loadReportDataWithReset = () => {
        this.setState({
            reportDataLoaded: false
        });
        this.loadReportData();
    }

    handleChangeIndex = index => {
        this.setState({value: index});
    };

    onUnitChange = (e) => {
        this.setState({selectedunit: e.target.value})
    }

    onNumberChange = (e) => {
        store.dispatch(storeSelectedNumber(e.target.value))
    }

    render() {
        return (
            <div>
                <Grid container>
                    <ItemGrid xs={12} sm={12} md={12}>
                        <TextField
                            maxLength="4"
                            label="how long in past"
                            value={this.props.selectednumber}
                            onChange={this.onNumberChange}
                        />

                        &nbsp;

                        <Select
                            value={this.state.selectedunit}
                            onChange={this.onUnitChange}
                        >
                            {/*<MenuItem value={"seconds"}>seconds</MenuItem>*/}
                            {/*<MenuItem value={"minutes"}>minutes</MenuItem>*/}
                            {/*<MenuItem value={"hours"}>hours</MenuItem>*/}
                            <MenuItem value={"days"}>days</MenuItem>
                        </Select>

                        &nbsp;
                        &nbsp;

                        <Button color="info" round={false} onClick={() => this.loadReportDataWithReset()}>Submit</Button>

                    </ItemGrid>
                </Grid>

                <br/>

                <Grid container>
                    <ItemGrid xs={12} sm={6} md={3}>
                        <StatsCard
                            icon={ShoppingCart}
                            iconColor="orange"
                            title="Placed Orders"
                            description={this.getPlacedOrderNumber()}
                            small=""
                            statIcon={DateRange}
                            statText={"Past " + this.props.selectednumber + " " + this.state.activeunit}
                        />
                    </ItemGrid>
                    <ItemGrid xs={12} sm={6} md={3}>
                        <StatsCard
                            icon={Input}
                            iconColor="green"
                            title="Submitted Orders"
                            description={this.getSubmittedOrderNumber()}
                            statIcon={DateRange}
                            statText={"Past " + this.props.selectednumber + " " + this.state.activeunit}
                        />
                    </ItemGrid>
                    <ItemGrid xs={12} sm={6} md={3}>
                        <StatsCard
                            icon={LocalOffer}
                            iconColor="purple"
                            title="Engaged Orders"
                            description={this.getEngagedOrderNumber()}
                            statIcon={DateRange}
                            statText={"Past " + this.props.selectednumber + " " + this.state.activeunit}
                        />
                    </ItemGrid>
                    <ItemGrid xs={12} sm={6} md={3}>
                        <StatsCard
                            icon={Store}
                            iconColor="blue"
                            title="Confirmed Orders"
                            description={this.getConfirmedOrderNumber()}
                            statIcon={DateRange}
                            statText={"Past " + this.props.selectednumber + " " + this.state.activeunit}
                        />
                    </ItemGrid>
                </Grid>
                <Grid container>
                    <ItemGrid xs={12} sm={12} md={6}>
                        <ChartCard
                            chart={
                                <ChartistGraph
                                    className="ct-chart"
                                    data={this.getChartData(this.props.reportData.dailySubmittedMap)}
                                    type="Line"
                                    options={this.getChartOptions(this.props.reportData.dailySubmittedMap)}
                                    // listener={dailyOrderChart.animation}
                                />
                            }
                            chartColor="green"
                            title="Submitted Order Chart"
                            statIcon={DateRange}
                            statText={"Past " + this.props.selectednumber + " " + this.state.activeunit}
                        />
                    </ItemGrid>

                    <ItemGrid xs={12} sm={12} md={6}>
                        <ChartCard
                            chart={
                                <ChartistGraph
                                    className="ct-chart"
                                    data={this.getChartData(this.props.reportData.dailyConfirmedMap)}
                                    type="Line"
                                    options={this.getChartOptions(this.props.reportData.dailyConfirmedMap)}
                                    // listener={dailyOrderChart.animation}
                                />
                            }
                            chartColor="blue"
                            title="Confirmed Order Chart"
                            statIcon={DateRange}
                            statText={"Past " + this.props.selectednumber + " " + this.state.activeunit}
                        />
                    </ItemGrid>
                </Grid>

                <Grid container>
                    <ItemGrid xs={12} sm={12} md={6}>
                        <ChartCard
                            chart={
                                <ChartistGraph
                                    className="ct-chart"
                                    data={this.getBarData(this.props.reportData.emailsByProduct)}
                                    type="Bar"
                                    options={this.getBarOptions(this.props.reportData.emailsByProduct)}
                                    responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                                    // listener={emailsSubscriptionChart.animation}
                                />
                            }
                            chartColor="orange"
                            title="Emails By Product"
                            text="Top 3"
                            statIcon={DateRange}
                            statText={"Past " + this.props.selectednumber + " " + this.state.activeunit}
                        />
                    </ItemGrid>

                    <ItemGrid xs={12} sm={12} md={6}>
                        <ChartCard
                            chart={
                                <ChartistGraph
                                    className="ct-chart"
                                    data={this.getBarData(this.props.reportData.emailsByUnit)}
                                    type="Bar"
                                    options={this.getBarOptions(this.props.reportData.emailsByUnit)}
                                    responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                                    // listener={emailsSubscriptionChart.animation}
                                />
                            }
                            chartColor="green"
                            title="Emails By Unit"
                            text="Top 3"
                            statIcon={DateRange}
                            statText={"Past " + this.props.selectednumber + " " + this.state.activeunit}
                        />
                    </ItemGrid>

                    {/*<ItemGrid xs={12} sm={12} md={4}>*/}
                        {/*<ChartCard*/}
                            {/*chart={*/}
                                {/*<ChartistGraph*/}
                                    {/*className="ct-chart"*/}
                                    {/*data={emailsSubscriptionChart.data}*/}
                                    {/*type="Bar"*/}
                                    {/*options={emailsSubscriptionChart.options}*/}
                                    {/*responsiveOptions={emailsSubscriptionChart.responsiveOptions}*/}
                                    {/*listener={emailsSubscriptionChart.animation}*/}
                                {/*/>*/}
                            {/*}*/}
                            {/*chartColor="purple"*/}
                            {/*title="Design Popularity"*/}
                            {/*text="Todo: graphic, logo, or text?"*/}
                            {/*statIcon={DateRange}*/}
                            {/*statText={"Past " + this.state.activenumber + " " + this.state.activeunit}*/}
                        {/*/>*/}
                    {/*</ItemGrid>*/}
                </Grid>

                <Grid container>
                    <ItemGrid xs={12} sm={12} md={12}>
                        <IssuesCard/>
                    </ItemGrid>
                </Grid>
            </div>
        );
    }

    getPlacedOrderNumber() {
        if (this.state.reportDataLoaded) {
            return this.props.reportData.summary.placed;
        } else {
            return 0;
        }
    }

    getSubmittedOrderNumber() {
        if (this.state.reportDataLoaded) {
            return this.props.reportData.summary.submitted;
        } else {
            return 0;
        }
    }

    getEngagedOrderNumber() {
        if (this.state.reportDataLoaded) {
            return this.props.reportData.summary.engaged;
        } else {
            return 0;
        }
    }

    getConfirmedOrderNumber() {
        if (this.state.reportDataLoaded) {
            return this.props.reportData.summary.confirmed;
        } else {
            return 0;
        }
    }

    getChartData(aMap) {
        return {
            labels: this.getChartLabels(aMap),
            series: this.getChartSeries(aMap)
        };
    }

    getChartOptions(aMap) {
        return {
            lineSmooth: Chartist.Interpolation.cardinal({
                tension: 0
            }),
            low: 0,
            high: this.getChartHigh(aMap), // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }
        }
    }

    getChartLabels(aMap) {
        if (this.state.reportDataLoaded) {
            return Object.keys(aMap);
        } else {
            return 0;
        }
    }

    getChartSeries(aMap) {
        if (this.state.reportDataLoaded) {
            var keys = Object.keys(aMap);
            var ret = [keys.map(function (v) {
                return aMap[v];
            })];
            return ret;
        } else {
            return 0;
        }
    }

    getChartHigh(aMap) {
        if (this.state.reportDataLoaded) {
            var keys = Object.keys(aMap);
            return Math.pow(10, Math.max(...keys.map(function (v) {
                return aMap[v];
            })).toString().length - 1) * (parseInt(Math.max(...keys.map(function (v) {
                return aMap[v];
            })).toString()[0]) * 1.66)
        } else {
            return 0;
        }
    }

    getBarData(aMap) {
        return {
            labels: this.getBarLabels(aMap),
            series: this.getBarSeries(aMap)
        };
    }

    getBarOptions(aMap) {
        return {
            axisX: {
                showGrid: false
            },
            low: 0,
            high: this.getBarHigh(aMap),
            chartPadding: {
                top: 0,
                right: 5,
                bottom: 0,
                left: 5
            }
        }
    }

    getBarLabels(aMap) {
        if (this.state.reportDataLoaded) {
            return Object.keys(aMap);
        } else {
            return 0;
        }
    }

    getBarSeries(aMap) {
        if (this.state.reportDataLoaded) {
            var keys = Object.keys(aMap);
            var ret = [keys.map(function (v) {
                return aMap[v];
            })];
            return ret;
        } else {
            return 0;
        }
    }

    getBarHigh(aMap) {
        if (this.state.reportDataLoaded) {
            var keys = Object.keys(aMap);
            return Math.pow(10, Math.max(...keys.map(function (v) {
                return aMap[v];
            })).toString().length - 1) * (parseInt(Math.max(...keys.map(function (v) {
                return aMap[v];
            })).toString()[0]) * 1.66)
        } else {
            return 0;
        }
    }
}

const mapStateToProps = state => {
    return {
        selectednumber: state.reportState.selectednumber,
        reportData: state.reportState.reportData,
        accessToken: state.authState.accessToken
    }
};

const Dashboard = connect(
    mapStateToProps
)(DashboardPage);

export default withStyles(dashboardStyle)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx